// Landing is served as static HTML from /public. React mounts nothing.
export default function App() {
  return null;
}
